import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import '../css/VerificationUpload.css';
import '../css/ContractCancelation.css';
import { ExtendedButton,TextField,MessageBox,DateField,SelectField } from 'component-lib';
import { DateTimeHelper,CurrencyConverter,CheckValues } from 'utils-lib';
import { RequestAjaxClass, ContractsModel, DocumentsModel } from 'models-lib';

var moment = require('moment');
moment().format();

var reason = '';

var cancelationReason;
var downloadClicked = false;

class ContractCancel extends Component
{
    constructor(props)
    {
        super(props);
        this.state= {};
        this.Contract = JSON.parse(localStorage.getItem('contract'));
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ContractModel = new ContractsModel([this],null,this.Request);
        this.DocumentsModel = new DocumentsModel([this],null,this.Request2);
        this.ReportingDateModel = new ContractsModel([this],"FirstDate",this.Request2);
        this.state.ShowCosts = false;
        this.state.CostsValue = '0,00';
    }

    componentDidMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });
      
      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      this.Request2.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });

      this.ContractModel.GetFilteredCancelationReasons(this.Contract.Id);

      this.showDocumentDownloadButton();

      this.LogoClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "CancelationReasons"){

            let result = this.ContractModel.CancelationReasons;
            let reasons = [];
            for (let i = 0; i< result.length; i++){
                let reason = { Key:result[i].Id, Display: result[i].Description };
                reasons.push(reason);
            }
            if (reasons.length === 1){
              me.setState({ Reason:result[0].Id });
            }
            me.refs.CancelationReasons.setState({ Data:reasons });
            $("#LoadingIcon").removeClass().addClass('hide');
        }
        else if(observer === "CancelationCosts" ){
          $("#LoadingIcon").removeClass().addClass('hide');
          document.getElementById('costsHint').innerHTML = '';
          this.refs.btoDone.setState({ usable:true });
          if (this.ContractModel.CancelationCosts[0] ){
              let result = this.ContractModel.CancelationCosts[0];
              if($('#CancelationDate').val() !== DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(result.ContractEnd,true,localStorage.getItem('vas_language')))){
                document.getElementsByClassName('ContractNotPossible')[0].classList.remove('hide');
                document.getElementsByClassName('ContractPossible')[0].classList.add('hide');
              }else{
                document.getElementsByClassName('ContractNotPossible')[0].classList.add('hide');
                document.getElementsByClassName('ContractPossible')[0].classList.remove('hide');
              }
              $('#CancelationDate').val(DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(result.ContractEnd,true,localStorage.getItem('vas_language'))));
              
              let showCosts = false;
              if(result.AdditionalPayment > 0){
                showCosts = true;
              }
              me.setState({
                ShowCosts : showCosts,
                CostsValue : CurrencyConverter.Cast(Math.abs(result.AdditionalPayment),localStorage.getItem('vas_language'),2)
              },()=>{
                if(showCosts === true){
                  $('#Costs').val(me.state.CostsValue);
                  document.getElementById('costsHint').innerHTML = Vas.Resources.Titles["Note"] + ": " +Vas.Resources.Labels["CostsHint"];
                }
              })
              
          }
        }
        else if( observer === "ContractCancelation"){
          //if(this.CustomerId !== undefined){
            localStorage.removeItem('contract');
            Vas.GetView("ContractCancelSuccessContractCard",{CustomerId : this.Contract.IdCustomer, ContractId: this.Contract.Id, CustomerName : this.Contract.CustomerName},true);
          //} else {
            //Vas.GetView("ContractCancelSuccess",null,true);
          //}
          
          $("#LoadingIcon").removeClass().addClass('hide');
        }
        else if(observer === "FirstDate"){
          $("#LoadingIcon").removeClass().addClass('hide');
          document.getElementById('costsHint').innerHTML = '';
          //this.refs.btoDone.setState({ usable:true });

          let result = this.ReportingDateModel.CancelationCosts[0];
          let date = DateTimeHelper.StringToDate(result.ContractEnd,true,localStorage.getItem('vas_language'))
          
          $('#CancelationDate').val(DateTimeHelper.FormatToShortDateString(date));
                    
          this.refs.CancelationDate.setState({MinValue : moment([date.year(),date.month(),date.date()])});
        }

        //Hier das Dokument runterladen, Download nur, wenn der Downloadbutton gedrückt wurde
        if(me.DocumentsModel.Documents.length > 0 && downloadClicked)
        {

          //Das Ergebnis ist ein Bytestream und der MIME-Type des Dokuments
          var fileInformationArray = me.DocumentsModel.base64ToArrayBuffer(me.DocumentsModel.Documents[0],me);

          var sampleArr = fileInformationArray[0];

          var fileType = fileInformationArray[1];

          me.DocumentsModel.saveByteArray(sampleArr,"Kündigungsdokument." + fileType);
          
          downloadClicked = false;
        }
      });
    }

    getCostsCancelation(){
        if (document.getElementById("CancelationReasons").selectedIndex > 0 && document.getElementById('CancelationDate').value.length > 0){

             let cur = '';
            let date = moment();
            if (document.getElementById("CancelationReasons").selectedIndex > 0){
              
               cur = DateTimeHelper.StringToDate(document.getElementById("CancelationDate").value,false,localStorage.getItem('vas_language'));
               date = cur.format('YYYY-MM-DD T 00:00:00');
            }
            
            this.Request.setErrorHandler((error)=>{
              $("#LoadingIcon").removeClass().addClass('hide');
              document.getElementById("CancelationReasons").selectedIndex = 0;
              this.refs.btoDone.setState({ usable:true });
              $('#Costs').val('');
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={error.responseJSON.Description} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            });

            this.refs.btoDone.setState({ usable:false });
            $("#LoadingIcon").removeClass().addClass('loaderSmall');
            this.ContractModel.GetCancelationCosts(this.Contract.Id,this.state.Reason,date);

        } else {
          $("#LoadingIcon").removeClass().addClass('hide');
        }

        this.showDocumentDownloadButton();
    }

    Cancel()
    {
      if(cancelationReason !== undefined && cancelationReason.FlagDocumentNeeded && cancelationReason.DocumentAvailable){

        this.DocumentsModel.GetDocumentById(cancelationReason.IdDocument);

        downloadClicked = true;

      } else if ($('#CancelationDate').val().length > 0 && document.getElementById('CancelationReasons').selectedIndex > 0){

            $("#LoadingIcon").removeClass().addClass('loaderSmall');
            this.refs.btoDone.setState({ usable:false });
            let cur = DateTimeHelper.StringToDate($('#CancelationDate').val(),false,localStorage.getItem('vas_language'));
            let date = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");

            this.ContractModel.SetRequest(this.Request);
            this.Request.setErrorHandler(()=>{
              ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Message={Vas.Resources.Labels["CancelationNoSuccess"]}
                Title={Vas.Resources.Titles["Note"]} />, document.getElementById('messageContainer'));   
              $("#LoadingIcon").removeClass().addClass('hide');
              
            })
            this.ContractModel.ContractCancelation(this.Contract.Id,this.state.Reason,date);

        } else {
            let docs=document.querySelectorAll('select,input');
            let docRefs = this.refs;
            CheckValues.checkAllFields(docs,docRefs,"");
            ReactDOM.render(<MessageBox
              Message={Vas.Resources.Labels["NotAllFields"]}
              Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
        }
    }

    Close(){
      Vas.GetView("Contract",{Id: this.Contract.Id,CustomerId:this.Contract.IdCustomer, CustomerName:this.Contract.CustomerName}, true);
    }

    showDocumentDownloadButton(){//Methode um die Buttons für die Vertragskündigung bzw. den Dokumentendownload ein bzw. auszublenden

      reason = this.state.Reason;
      cancelationReason = this.ContractModel.CancelationReasons.filter(function (r) { return r.Id === reason })[0];

      //Wenn Dokument vorhanden, dann Anzeige Button für Dokumentendownload statt Button für Vertragskündigung

      if(cancelationReason !== undefined && cancelationReason.FlagDocumentNeeded && cancelationReason.DocumentAvailable){
        $('#DateCalcelation').removeClass().addClass('hide');
        $('#CostsCancelation').removeClass().addClass('hide');
        $('#CancelationDocumentHint').removeClass('hide').addClass('display');

        document.getElementById("Cancel").innerHTML = Vas.Resources.Labels["Download"];

      }
      else{
        $('#DateCalcelation').removeClass().addClass('display');
        $('#CostsCancelation').removeClass().addClass('display');
        $('#CancelationDocumentHint').removeClass('display').addClass('hide');

        document.getElementById("Cancel").innerHTML = Vas.Resources.Labels["ContractCancel"];
      }
    }

    Check(){
      this.getCostsCancelation();
    }

    GetfirstCancelationDate(){
      this.ReportingDateModel.GetCancelationCosts(this.Contract.Id,this.state.Reason);
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        
        $('#CancelationReasons').attr('style', 'width: 360px; border-bottom: 1px dotted #1d5c87;');
        $('#Check').attr('style', 'width: 177px; float: left; background-color: #1d5c87;');
       
        $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
      }
    }

    render()
    {
        /*let date = moment();
        if (this.state.MinDate){
            date= this.state.MinDate;
        } else {
            let contractStart = DateTimeHelper.StringToDate(this.Contract.DateFrom,false,localStorage.getItem('vas_language')).subtract(1,'month');
            let lastDay = DateTimeHelper.GetLastDayOfMonth(contractStart.month(),contractStart.year());
            date = moment([contractStart.year(),contractStart.month(),lastDay]);
        }*/

        let costs = <div></div>;
        if(this.state.ShowCosts === true){
          costs = (
            <TextField
                    AppURL={Vas.ApplicationUrl}
                    ref={"Costs"}
                    Id="Costs"
                    Editable={false}
                    Label={Vas.Resources.Labels["CancelationCosts"]}
                     />
          );
        }
        
        return (
          <div className={"form contractCancelForm"}>
            <div><table>
              <thead>
                <tr>
                  <th>
                    {Vas.Resources.Labels["ContractCancel"]}
                  </th>
                  <th>
                  <div
                    id={"LoadingIcon"}
                    className={'hide'}></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2}>
                    <SelectField
                      AppURL={Vas.ApplicationUrl}
                      Id={"CancelationReasons"} 
                      ref={"CancelationReasons"}
                      Width={360}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["CancelationReason"]+"*"} 
                      OnChange={()=>{
                        this.refs.btoDone.setState({ usable:false });
                        this.setState({ Reason:$('#CancelationReasons').val() },()=>{
                          document.getElementsByClassName('ContractNotPossible')[0].classList.remove('hide');
                          document.getElementsByClassName('ContractNotPossible')[0].classList.add('hide');
                          document.getElementsByClassName('ContractPossible')[0].classList.remove('hide');
                          document.getElementsByClassName('ContractPossible')[0].classList.add('hide');
                          this.GetfirstCancelationDate();
                        });
                      }} 
                      LabelHeight={15}/> 
                  </td>
                </tr>
                <tr id={'DateCalcelation'}>
                  <td>
                    <DateField
                      AppURL={Vas.ApplicationUrl}
                      Language={localStorage.getItem("vas_language")}
                      ref={"CancelationDate"}
                      Width={170}
                      Editable={true}
                      Id={"CancelationDate"}
                      Label={Vas.Resources.Labels["CancelationDate"]+"*"} 
                      OnChange={()=>{
                        this.refs.btoDone.setState({ usable:false });
                        document.getElementById('costsHint').innerHTML = '';
                        $('#Costs').val();
                        this.setState({ ShowCosts : false});
                        document.getElementsByClassName('ContractNotPossible')[0].classList.add('hide');
                        document.getElementsByClassName('ContractPossible')[0].classList.add('hide');
                      }}
                      OnBlur={()=>{
                        this.refs.btoDone.setState({ usable:false });
                        document.getElementById('costsHint').innerHTML = '';
                        $('#Costs').val();
                        this.setState({ ShowCosts : false});
                        document.getElementsByClassName('ContractNotPossible')[0].classList.add('hide');
                        document.getElementsByClassName('ContractPossible')[0].classList.add('hide');
                      }}
                      /> 
                  </td>
                  <td>
                    <ExtendedButton
                        Id={'Check'}
                        Usable={true}
                        Text={Vas.Resources.Labels["CheckCancel"]}
                        Float={'left'}
                        OnClick={()=>{  this.Check();}}
                        Width={177}
                        />
                  </td>
                </tr>
                <tr>
                <td className={"ContractPossible hide"}>
                      {Vas.Resources.Labels["CancelationPossible"]}
                </td>
              </tr>
              <tr>
                <td className={"ContractNotPossible hide"}>
                      {Vas.Resources.Labels["CancelationNotPossible"]}
                </td>
              </tr>
                <tr id={'CostsCancelation'}>
                  <td>{costs}</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div id={"costsHint"} className={"costsHint"}></div>
                  </td>
                </tr>
                <tr id={'CancelationDocumentHint'}>
                <td>
                  <div className={'DownloadCancelationDocumentHint'}>
                    <br/>
                    {Vas.Resources.Labels["DownloadCancelationDocumentHint1"]} <br/><br/>
                    
                    <div style={{ fontStyle: 'italic', textAlign: 'center', width: '300px' }}>{Vas.Resources.Labels["Address"]}</div> <br/>
                    
                    {Vas.Resources.Labels["DownloadCancelationDocumentHint2"]} <br/><br/>
                  </div>
                </td>
              </tr>
                <tr>
                  <td>
                    <div style={{float:'left'}} className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                  </td>
                </tr>
                <tr>
                  <td >
                    <ExtendedButton
                      Id={'Abort'}
                      Usable={true}
                      Text={Vas.Resources.Labels["Cancel"]}
                      Float={'left'}
                      OnClick={()=>{  this.Close();}}
                      Width={172}
                      />
                    <ExtendedButton
                      Id={'Cancel'}
                      Usable={false}
                      ref={"btoDone"}                      
                      Text={Vas.Resources.Labels["ContractCancel"]}
                      Float={'left'}
                      OnClick={()=>{this.Cancel();}}
                      Width={172}
                      />
                  </td>
                  <td>   
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>  
          </div>
        );
    }
}
export default ContractCancel;
